import { StorageItem } from "@dashboard/constants/storage-items";

export const SIGNUP_COUPON_STORAGE_KEY = StorageItem.SignupCoupon;

export function normalizeSignupCoupon(
  params?: Record<string, string> | URLSearchParams | null
): string {
  if (!params) return "";

  const read = (key: string) => {
    if (params instanceof URLSearchParams) {
      return params.get(key) || "";
    }
    return params[key] || "";
  };

  return (read("cupon") || read("coupon") || "").trim();
}

export function buildParameterCheckCodeUserFromParams(
  params: Record<string, string>
): Record<string, string> | undefined {
  const payload: Record<string, string> = {};
  const coupon = normalizeSignupCoupon(params);

  if (params.fbclid) payload.fbclid = params.fbclid;
  if (params.gclid) payload.gclid = params.gclid;
  if (params.utm_source) payload.utm_source = params.utm_source;
  if (params.utm_medium) payload.utm_medium = params.utm_medium;
  if (params.utm_campaign) payload.utm_campaign = params.utm_campaign;
  if (coupon) payload.coupon = coupon;

  return Object.keys(payload).length ? payload : undefined;
}

export function persistSignupCoupon(coupon: string): void {
  if (!coupon) return;
  sessionStorage.setItem(SIGNUP_COUPON_STORAGE_KEY, coupon);
}

export function readPersistedSignupCoupon(): string {
  return sessionStorage.getItem(SIGNUP_COUPON_STORAGE_KEY) || "";
}

export function clearPersistedSignupCoupon(): void {
  sessionStorage.removeItem(SIGNUP_COUPON_STORAGE_KEY);
}
